import { useCallback, useRef } from "react";

const controllers = new Set();

// Managing multiple concurrent instances of API requests
const useAbortController = () => {
  const abortAllControllers = () => {
    if (controllers?.size <= 0) {
      return;
    }

    for (const controller of controllers) {
      controller.abort();
    }
    controllers.clear();
  };

  /**
   * Allows to manage multiple concurrent instances of API-requests and aborting those
   *
   * 1: Abort all existing/pending/old API requests/controllers
   * 2: Create a new controller for the current API request
   * 3: Call the passed API request function and force signal as a param
   *  NOTE: Each API function should allow signal as a param and use it inside fetch with ...(signal ? { signal } : {}),
   * 4: Remove the current controller/API request when completed
   */
  const runAbortable = async (apiFn, params) => {
    // Abort old requests
    abortAllControllers();

    const controller = new AbortController();
    controllers.add(controller);
    const signal = controller.signal;

    // Ensure we clean up after request finishes
    return Promise.resolve(apiFn(params, signal)).finally(() => {
      controllers.delete(controller);
    });
  };

  return {
    runAbortable: runAbortable,
  };
};
export default useAbortController;
